import { Upload } from 'antd';
export * from 'antd-img-crop';
export default Upload;
